

let swiperFaq = null;

function initOrDestroySwiper() {
  const breakpoint = 1023;
  const isMobile = window.innerWidth >= breakpoint;

  // Destroy Swiper if initialized and on mobile
  if (isMobile && swiperFaq) {
    swiperFaq.destroy(true, true);
    swiperFaq = null;
    return;
  }

  // Init Swiper if not initialized and not mobile
  if (!isMobile && !swiperFaq) {
    swiperFaq = new Swiper(".faq-swiper", {
      loop: true,
      centeredSlides: true,
      slidesPerView: "auto",
      spaceBetween: 16,
      slideToClickedSlide: true,
      on: {
        slideChange: function () {
          updateSliderAnswers();
        },
      },
    });

    // Ensure answer is updated on init
    updateSliderAnswers();
  }
}

// Run on load and on resize
window.addEventListener("load", initOrDestroySwiper);
window.addEventListener("resize", initOrDestroySwiper);

// Your original function remains untouched
function updateSliderAnswers() {
  const activeSlide = document.querySelector(
    ".faq-swiper .swiper-slide-active"
  );

  if (activeSlide) {
    const content =
      activeSlide.querySelector(".faq-swiper-answer")?.innerHTML || "";
    const sliderAnswers = document.querySelector("#slider-answers");

    // Trigger bounce animation
    sliderAnswers.classList.remove("active");
    sliderAnswers.innerHTML = content;

    // Delay to re-add animation class
    setTimeout(() => {
      sliderAnswers.classList.add("active");
    }, 200);
  }
}
